import { render, staticRenderFns } from "./platinfouser.vue?vue&type=template&id=56065664&"
import script from "./platinfouser.vue?vue&type=script&lang=js&"
export * from "./platinfouser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports